module.exports = __webpack_public_path__ + "static/media/card_amex.61813c93.png";